import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import logo from '@assets/654global.svg';
import noResult from '@assets/noResult.svg';
import { Button } from '@components/Button/Button';
import Image from '@components/Image/Image';
import { ERoutes } from '@enums/routes.enum';
import { EStyles } from '@enums/style.enum';
import { ETranslate } from '@enums/translate.enum';
import { reset } from '@store/auth/authSlice';
import type { RootState } from '@store/store';

import classes from './NoResults.module.scss';

const NoResults: React.FC = () => {
	const flightNumber = useSelector((state: RootState) => state.auth.flightNumber);
	const vehicleId = useSelector((state: RootState) => state.auth.vehicleId);

	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleStartNewSearch = () => {
		dispatch(reset());
		navigate(ERoutes.search);
	};

	return (
		<div className={classes['container']}>
			<img src={logo} alt="654 Global" className={classes['logo']} />
			<h1 className={classes['title']}>
				{vehicleId
					? t('noResults.vehicleNotFound')
					: t('noResults.title').replace(ETranslate.FlightNumber, flightNumber || EStyles.emptyQuote)}
			</h1>
			<div className={classes['imageContainer']}>
				<Image src={noResult} name={t('search.imgAlt')} size="85dvw" />
			</div>
			{!vehicleId && (
				<Button primary fullWidth onClick={handleStartNewSearch}>
					{t('noResults.button')}
				</Button>
			)}
		</div>
	);
};

export default NoResults;
